import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=aa6fe7c0&scoped=true&"
import script from "./receiver.vue?vue&type=script&lang=js&"
export * from "./receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6fe7c0",
  null
  
)

export default component.exports